<template>
  <div>
    <!-- EVALUATION QUESTIONS COMMENTS MODAL -->
    <div class="text-center">
      <v-dialog v-model="dialog_evaluation_question_comments" max-width="500px" scrollable>
        <v-row justify="center">
          <v-card
            style="padding: 3%;"
          >
            <v-form
              ref="comments_form"
              v-model="valid"
              lazy-validation
            >
              <v-card-title>
                <v-toolbar class="bg-white">
                  <v-toolbar-title>
                    Comments for Question
                  </v-toolbar-title>
                  <v-toolbar-items>
                    <v-btn
                      class="btn ml-4"
                      color="error"
                      @click="
                        dialog_evaluation_question_comments = !dialog_evaluation_question_comments;
                        alert.setChecked(null);
                        reset();
                      "
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <v-textarea
                      type="text"
                      v-model="comments"
                      label="Comments"
                      placeholder="Add Comments for Question"
                      variant="outlined"
                      :rules="rules.textRules"
                      :readonly="showReview || (category.isComplete == 1)"
                    ></v-textarea>
                  </v-col>
                </v-row>  
              </v-card-text>
              <v-card-actions v-if="!showReview && category.isComplete == 0">
                <v-btn
                  color="primary"
                  @click="
                    dialog_evaluation_question_comments = false;
                    alert.setChecked(null);
                    reset();
                  "
                  variant="flat"
                  elevation="1"
                >
                  Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  @click="
                    commentEvaluation();
                  "
                  style="float: right;"
                  variant="flat"
                  elevation="1"
                  :loading="submit_loading"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-row>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";
import UserData from "../repository/UserData";
import axios from 'axios';

export default {
  name: "EvaluationQuestionCommentsDialog",
  props: {
    evaluation: {
      type: Object,
      default: () => {},
    },
    chairman: {
      type: String,
      default: "0",
    },
    category: {
      type: Object,
      default: () => {},
    },
    load: {
      type: Boolean,
      default: false,
    },
    selectedQuestion: {
      type: Object,
      default: () => {},
    },
    showReview: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    valid_comments: false,
    submit_loading: false,
    comments: "",
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
    selected: [],
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },

    dialog_evaluation_question_comments: {
      get() {
        return this.store.getDialogEvaluationQuestionComments;
      },
      set(value) {
        this.store.setDialogEvaluationQuestionComments(value);
      },
    },
  },

  watch: {
    selectedQuestion: {
      handler(val) {
        if (val.questionComment) {
          this.comments = val.questionComment;
        } else {
          this.comments = '';
        }
      },
      deep: true,
    },
  },
  
  methods: {
    validate() {
      return this.$refs.comments_form.validate();
    },

    resetForm() {
      return this.$refs.comments_form.reset();
    },

    resetValidation() {
      return this.$refs.comments_form.resetValidation();
    },

    reset() {
      this.comments = "";
      this.dialog_evaluation_question_comments = false;
      this.$emit('question_comments_opened', false);
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    commentEvaluation() {
      this.validate().then((validator_response) => {
        this.valid_comments = validator_response.valid;
        if (this.valid_comments && this.comments) {
          const formData = new FormData();
          formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
          formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
          formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
          formData.append("model", "updateCommentForEvaluationQuestion");
          formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
          formData.append("evaluationId", UserData.getEvaluationId() ? UserData.getEvaluationId() : this.store.getEvaluationId);
          formData.append("evaluateeId", UserData.getEvaluateeId() ? UserData.getEvaluateeId() : this.store.getEvaluateeId);
          formData.append("questionComment", this.comments);
          formData.append("categoryId", this.category.categoryId); 
          formData.append("questionId", this.selectedQuestion.questionId);
          
          this.submit_loading = true;
          axios.post(UserData.getBaseUrl(), formData).then((response) => {
            this.alert.showSuccess(response.data.message);
            this.submit_loading = false;
            this.$emit('submit_question_comments', { question: this.selectedQuestion, comments: this.comments });
            this.reset();
          })
          .catch((e) => {
            console.log("Error", e);
            this.submit_loading = false;
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.list-striped a {
  text-decoration: none;
  color: #000;
}

.list-striped a:hover {
  color: rgb(72, 61, 139);
}

.list-striped a:active {
  color: rgb(72, 61, 139);
}
</style>